// src/Dashboard/pages/user/ArbitrageJudo/components/ArbitrageSectionCard.jsx

import React from "react";
import { FaChevronDown, FaChevronUp, FaImage } from "react-icons/fa";

import ArbitrageAccordion from "./ArbitrageAccordion";

const FALLBACK_IMAGE = "/img/no-image.jpg";

export default function ArbitrageSectionCard({ section, isOpen, onToggle }) {
  const reverse = section.layout === "reverse";

  return (
    <article className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950">
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-start justify-between gap-4 p-4 text-left transition hover:bg-slate-50 dark:hover:bg-slate-900 sm:p-5"
      >
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <span className="rounded-full bg-[#013E8E]/10 px-3 py-1 text-xs font-bold text-[#013E8E] ring-1 ring-[#013E8E]/15 dark:bg-blue-900/20 dark:text-blue-200 dark:ring-blue-800/60">
              {section.category}
            </span>

            {section.kicker && (
              <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-500 ring-1 ring-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700">
                {section.kicker}
              </span>
            )}
          </div>

          <h3 className="mt-3 text-xl font-bold text-slate-950 dark:text-white">
            {section.title}
          </h3>

          {section.summary && (
            <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              {section.summary}
            </p>
          )}
        </div>

        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-slate-950 text-white dark:bg-white dark:text-slate-950">
          {isOpen ? <FaChevronUp /> : <FaChevronDown />}
        </span>
      </button>

      {isOpen && (
        <div className="border-t border-slate-200 p-4 dark:border-slate-800 sm:p-5">
          <div
            className={`grid gap-5 lg:grid-cols-2 lg:items-start ${
              reverse ? "lg:[&>*:first-child]:order-2" : ""
            }`}
          >
            <div className="space-y-3">
              {section.items?.map((item) => (
                <ArbitrageAccordion key={item.title} title={item.title}>
                  <div className="space-y-2">
                    {item.paragraphs?.map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                    ))}
                  </div>
                </ArbitrageAccordion>
              ))}
            </div>

            <div className="overflow-hidden rounded-[26px] border border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-900">
              {section.image ? (
                <img
                  src={section.image}
                  alt={section.title}
                  className="h-full max-h-[440px] w-full object-cover"
                  loading="lazy"
                  onError={(event) => {
                    event.currentTarget.src = FALLBACK_IMAGE;
                  }}
                />
              ) : (
                <div className="flex h-72 items-center justify-center text-slate-400">
                  <FaImage className="text-5xl" />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </article>
  );
}